import * as Yup from 'yup'

export const adminLoginSchema = Yup.object().shape({
    email: Yup
        .string()
        .email('올바르지 않은 이메일 형식입니다.')
        .required('이메일은 필수 입력 항목입니다.'),
    password: Yup
        .string()
        .min(8, '비밀번호는 최소 8자 이상이어야 합니다.')
        .matches(
            /^[a-zA-Z0-9!@#$%^&*]*$/,
            '비밀번호에 허용되지 않은 문자가 포함되어 있습니다.',
        )
        .required('비밀번호는 필수 입력 항목입니다.'),
})